























import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';

@Component
export default class MarkerPlus extends Vue {
  @Prop()
  public marker: string;

  @Prop()
  public content: string;

  @Prop()
  public spotWidth: number;

  @Prop()
  public spotHeight: number;

  @Prop()
  public isFirst: boolean;

  @Prop()
  public isLast: boolean;

  @Prop({
    default: 'right'
  })
  public popupPositionClass: string;

  @Prop({
    default: false
  })
  public popupIsActive: boolean = false;

  public popupIsActiveInternal: boolean = this.popupIsActive;

  @Prop({
    default: false
  })
  public seen: boolean;

  @Watch('popupIsActive')
  public onPopupIsActiveChanged(newValue: boolean): void {
    this.popupIsActiveInternal = newValue;

    if (newValue) {
      this.seen = true;
    }
  }

  public onClick() {
    this.popupIsActiveInternal = !this.popupIsActiveInternal;
    this.emitToggleMarkerPopup();

    this.seen = true;
  }

  @Emit('toggleMarkerPopup')
  public emitToggleMarkerPopup(): void {

  }

  @Emit('prev')
  public emitPrev(): void {
    if (!this.isFirst) {
      this.popupIsActiveInternal = false;
    }
  }

  @Emit('next')
  public emitNext(): void {
    if (!this.isLast) {
      this.popupIsActiveInternal = false;
    }
  }
}
